<template>
  <main class="wrapper wrapper-padding-top-0">
    <slot />
  </main>
</template>

<script setup>
defineOptions({
  name: 'LayoutPlain',
})

// LayoutPlain
// - Chrome-less layout for pages that supply their own header.
// - Reuses the global `.wrapper` width constraint (max-width 640px on
//   desktop) but drops the navigation and its top padding.
// - Never renders navigation regardless of environment, so there is no
//   `embedded` gating to do here.
</script>
